"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldItem = exports.FormFieldItemWrap = exports.FormField = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
exports.FormField = react_1.default.memo(({ className, gap, children, style, }) => {
    return (react_1.default.createElement("div", { className: `form ${className}`, style: { gap, ...style } }, children));
});
exports.FormFieldItemWrap = react_1.default.memo(({ className, style, width, children, }) => {
    return (react_1.default.createElement("div", { className: `task ${className}`, style: { width: `${width}`, ...style } }, children));
});
exports.FormFieldItem = react_1.default.memo(({ className, style, label, labelChild, width = '100%', labelWidth = 65, children, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement("div", { className: `task ${className ? className : ''}`, style: { width: `${width}`, ...style } },
        react_1.default.createElement("div", { className: "task-label-wrap" },
            react_1.default.createElement("p", { style: { minWidth: labelWidth }, className: "task-label" }, label && t(label)),
            labelChild),
        children));
});
